import { render, staticRenderFns } from "./Title_en.vue?vue&type=template&id=aaf0986e&scoped=true&"
import script from "./Title_en.vue?vue&type=script&lang=js&"
export * from "./Title_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf0986e",
  null
  
)

export default component.exports